import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=6721de50&lang=html&"
import script from "./RealEstate.vue?vue&type=script&lang=js&"
export * from "./RealEstate.vue?vue&type=script&lang=js&"
import style0 from "./RealEstate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports